"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _SimpleWrapper = _interopRequireDefault(require("./SimpleWrapper"));

/**
 * Form input wrapper which allows buttons/links/icons displayed alongside
 *
 * @candidate for spacesword extraction
 * @author Ben Anderson (@banderson)
 **/
var UIFormControlWithActions = _react.default.createClass({
  displayName: "UIFormControlWithActions",
  propTypes: {
    children: _react.PropTypes.node.isRequired,
    className: _react.PropTypes.string,
    disabled: _react.PropTypes.bool.isRequired,
    onRemove: _react.PropTypes.func.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      disabled: false,
      onRemove: _emptyFunction.default
    };
  },
  render: function render() {
    var _this$props = this.props,
        child = _this$props.children,
        className = _this$props.className,
        disabled = _this$props.disabled,
        onRemove = _this$props.onRemove,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "disabled", "onRemove"]);
    var classes = (0, _classNames.default)(className, 'private-form--removable');
    return _react.default.createElement(_UIFormControl.default, (0, _extends2.default)({}, rest, {
      className: classes
    }), _react.default.createElement(_SimpleWrapper.default, null, _react.Children.only(child), _react.default.createElement(_UIButton.default, {
      className: "private-form__remove-button",
      disabled: disabled,
      onClick: onRemove,
      use: "transparent"
    }, _react.default.createElement(_UIIcon.default, {
      name: "delete",
      className: "private-form__remove-icon"
    }))));
  }
});

var _default = UIFormControlWithActions;
exports.default = _default;
module.exports = exports.default;